import {FETCH_HADITH} from "../../actions";

export default (state = [], action) => {
    switch (action.type) {
        case FETCH_HADITH:
            return action.payload;
        default:
            return state;
    }
};